/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserSettingKey = {
    ClientFileColorCoding: 'ClientFileColorCoding'
} as const;
export type UserSettingKey = typeof UserSettingKey[keyof typeof UserSettingKey];


export function instanceOfUserSettingKey(value: any): boolean {
    for (const key in UserSettingKey) {
        if (Object.prototype.hasOwnProperty.call(UserSettingKey, key)) {
            if (UserSettingKey[key as keyof typeof UserSettingKey] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserSettingKeyFromJSON(json: any): UserSettingKey {
    return UserSettingKeyFromJSONTyped(json, false);
}

export function UserSettingKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSettingKey {
    return json as UserSettingKey;
}

export function UserSettingKeyToJSON(value?: UserSettingKey | null): any {
    return value as any;
}

export function UserSettingKeyToJSONTyped(value: any, ignoreDiscriminator: boolean): UserSettingKey {
    return value as UserSettingKey;
}

